import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import '@universityofmaryland/utilityheader';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Card } from '@/components/ui/card';

export default function Layout() {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Determine the active tab based on the current path
  const activeTab = location.pathname.startsWith('/apis') ? 'apis' : 'clients';

  return (
    <div className="min-h-screen bg-background">
      <umd-utility-header
        size="100%"
        padding="20px"
      ></umd-utility-header>
      <nav className="bg-card shadow-sm border-b">
        <div className="container mx-auto px-4">
          <div className="flex h-16 items-center justify-between">
            <div className="flex items-center space-x-3">
              <h1 className="text-lg font-semibold hidden md:block">OIDC Manager</h1>
              <Tabs
                value={activeTab}
                onValueChange={(value) => navigate(`/${value}`)}
                className="w-auto"
              >
                <TabsList className="bg-transparent">
                  <TabsTrigger 
                    value="clients"
                  >
                    Clients
                  </TabsTrigger>
                  <TabsTrigger 
                    value="apis"
                  >
                    APIs
                  </TabsTrigger>
                </TabsList>
              </Tabs>
            </div>
          </div>
        </div>
      </nav>
      {/* Main content */}
      <main className="flex-grow" role="main" id="main-content">
        <div className="container mx-auto px-4 py-6">
          <Card className="border shadow-sm p-1">
            <div className="p-4">
              <Outlet/>
            </div>
          </Card>
        </div>
      </main>
    </div>
  );
}